﻿import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Typography, Paper, Box } from "@mui/material";
import "./OperationsNavigation.css";
import {
  NewOrderFromCustomers,
  NewOrderFromCustomersHover,
  NewOrderFromCustomersClick,
  OrderChangeFromCustomer,
  OrderChangeFromCustomerHover,
  OrderChangeFromCustomerClick,
  OrderStatusToCustomers,
  OrderStatusToCustomersHover,
  OrderStatusToCustomersClick,
  NewOrderAcknowledgmentToCustomers,
  NewOrderAcknowledgmentToCustomersHover,
  NewOrderAcknowledgmentToCustomersClick,
  PickOrderToWarehouse,
  PickOrderToWarehouseHover,
  PickOrderToWarehouseClick,
  OrderChangeAcknowledgementToCustomer,
  OrderChangeAcknowledgementToCustomerHover,
  OrderChangeAcknowledgementToCustomerClick,
  RoutingRequestToCustomers,
  RoutingRequestToCustomersHover,
  RoutingRequestToCustomersClick,
  ShipmentRecordToAccounting,
  ShipmentRecordToAccountingHover,
  ShipmentRecordToAccountingClick,
  InvoiceRecordToAccounting,
  InvoiceRecordToAccountingHover,
  InvoiceRecordToAccountingClick,
  ShipmentNoticeToCustomers,
  ShipmentNoticeToCustomersHover,
  ShipmentNoticeToCustomersClick,
  RoutingInstructionsFromCustomers,
  RoutingInstructionsFromCustomersHover,
  RoutingInstructionsFromCustomersClick,
  InventoryCountFromWarehouse,
  InventoryCountFromWarehouseHover,
  InventoryCountFromWarehouseClick,
  InventoryTransferRequestToWarehouse,
  InventoryTransferRequestToWarehouseHover,
  InventoryTransferRequestToWarehouseClick,
  InventoryTransferConfirmationsFromWarehouse,
  InventoryTransferConfirmationsFromWarehouseHover,
  InventoryTransferConfirmationsFromWarehouseClick,
  ProductCatalogToCustomers,
  ProductCatalogToCustomersHover,
  ProductCatalogToCustomersClick,
  InventoryAvailabilityToCustomer,
  InventoryAvailabilityToCustomerHover,
  InventoryAvailabilityToCustomerClick,
  InvoiceToCustomer,
  InvoiceToCustomerClick,
  InvoiceToCustomerHover,
  CreditNoteToCustomer,
  CreditNoteToCustomerClick,
  CreditNoteToCustomerHover,
} from "../../ImageRepo";
import {
  selectCurrentOperations,
  selectCurrentOperationId,
  setCurrentOperation,
} from "@/features/operations/operationsSlice";

const OperationsNavigation = ({ forceSelection = false }) => {
  const dispatch = useDispatch();
  const operationList = useSelector(selectCurrentOperations);
  //temporary for Alpha
  const filteredOperationList = operationList?.filter((operation) =>
    [101010, 101020, 103010].includes(operation.operationId)
  );
  const currentOperationId = useSelector(selectCurrentOperationId);

  const icons = {
    NewOrderFromCustomers,
    NewOrderFromCustomersHover,
    NewOrderFromCustomersClick,
    OrderChangeFromCustomer,
    OrderChangeFromCustomerHover,
    OrderChangeFromCustomerClick,
    OrderStatusToCustomers,
    OrderStatusToCustomersHover,
    OrderStatusToCustomersClick,
    NewOrderAcknowledgmentToCustomers,
    NewOrderAcknowledgmentToCustomersHover,
    NewOrderAcknowledgmentToCustomersClick,
    PickOrderToWarehouse,
    PickOrderToWarehouseHover,
    PickOrderToWarehouseClick,
    OrderChangeAcknowledgementToCustomer,
    OrderChangeAcknowledgementToCustomerHover,
    OrderChangeAcknowledgementToCustomerClick,
    RoutingRequestToCustomers,
    RoutingRequestToCustomersHover,
    RoutingRequestToCustomersClick,
    ShipmentRecordToAccounting,
    ShipmentRecordToAccountingHover,
    ShipmentRecordToAccountingClick,
    InvoiceRecordToAccounting,
    InvoiceRecordToAccountingHover,
    InvoiceRecordToAccountingClick,
    ShipmentNoticeToCustomers,
    ShipmentNoticeToCustomersHover,
    ShipmentNoticeToCustomersClick,
    RoutingInstructionsFromCustomers,
    RoutingInstructionsFromCustomersHover,
    RoutingInstructionsFromCustomersClick,
    InventoryCountFromWarehouse,
    InventoryCountFromWarehouseHover,
    InventoryCountFromWarehouseClick,
    InventoryTransferRequestToWarehouse,
    InventoryTransferRequestToWarehouseHover,
    InventoryTransferRequestToWarehouseClick,
    InventoryTransferConfirmationsFromWarehouse,
    InventoryTransferConfirmationsFromWarehouseHover,
    InventoryTransferConfirmationsFromWarehouseClick,
    ProductCatalogToCustomers,
    ProductCatalogToCustomersHover,
    ProductCatalogToCustomersClick,
    InventoryAvailabilityToCustomer,
    InventoryAvailabilityToCustomerHover,
    InventoryAvailabilityToCustomerClick,
    InvoiceToCustomer,
    InvoiceToCustomerClick,
    InvoiceToCustomerHover,
    CreditNoteToCustomer,
    CreditNoteToCustomerClick,
    CreditNoteToCustomerHover,
  };

  const getIconsByName = (operationName) => {
    const cleanedOperationName = operationName.replace(/\s/g, "");
    return icons[cleanedOperationName];
  };

  const onClickOperation = (operationId) => {
    if (!forceSelection && currentOperationId === operationId)
      operationId = null;
    dispatch(setCurrentOperation({ currentOperationId: operationId }));
  };

  return (
    <Container>
      <Box className="navbar-panel">
        <Box className="navbar-container">
          <Box className="navbar-item">
            <Box className="extended-navbar-container">
              {filteredOperationList?.map((operation, index) => (
                <Fragment key={index}>
                  <Paper
                    elevation={2}
                    key={operation.operationId}
                    className="extended-navbar-outer-item"
                  >
                    <Paper
                      elevation={1}
                      className={
                        "extended-navbar-item " +
                        (operation.operationId === currentOperationId
                          ? "selected"
                          : "")
                      }
                      onClick={() => onClickOperation(operation.operationId)}
                    >
                      <Box className="operation-container">
                        <Box className="operation-icon-container">
                          <img
                            className="operation-icon inactive"
                            src={getIconsByName(operation.name)}
                          />
                          <img
                            className={"operation-icon hover"}
                            src={getIconsByName(operation.name + "Hover")}
                          />
                          <img
                            className="operation-icon clicked"
                            src={getIconsByName(operation.name + "Click")}
                          />
                        </Box>
                        <Box>
                          <Typography className="operation-name-levelOne">
                            {operation.name.substring(
                              0,
                              operation.name.indexOf("To") !== -1
                                ? operation.name.indexOf("To")
                                : operation.name.indexOf("From")
                            )}
                          </Typography>
                          <Typography className="operation-name-levelTwo">
                            {operation.name.substring(
                              operation.name.indexOf("To") !== -1
                                ? operation.name.indexOf("To")
                                : operation.name.indexOf("From")
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Paper>
                  {filteredOperationList.length - 1 != index && (
                    <Box
                      className="navbar-divider"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Paper className="extended-navbar-inner-item-white inner-top"></Paper>
                      <Paper
                        className="extended-navbar-inner-item"
                        style={{ marginTop: -4 }}
                      ></Paper>
                      <Paper
                        className="extended-navbar-inner-item-white inner-bottom"
                        style={{ marginTop: -4 }}
                      ></Paper>
                    </Box>
                  )}
                </Fragment>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default OperationsNavigation;
